$(function() {
    require('backbone.radio');
    require('../vendor/bootstrap-grid-flexbox/bootstrap-grid-flexbox.scss');
    require('./public-menu-app.scss');
    var Moment = require('moment');
    var MomentRange = require('moment-range');
    var moment = MomentRange.extendMoment(Moment);
    var MapboxClient = require('mapbox');
    // TODO, obv store these keys in config for each env. and lock down to domain...
    var mbxBaseClient = new MapboxClient('pk.eyJ1Ijoib2dmYXJtIiwiYSI6ImNrcTcyOW5jdjAwamsydXBnOHB1eTU0bG0ifQ.gJU9G9adyvvv8X4UBdUGhw');
    var NodeGeocoder = require('google-geocoder');
    var MenuProductEntities = require('./common/menu/menu-product');
    var LocationEntities = require('./entities/location');
    var ProductVendorEntities = require('./admin-app/entities/product-vendor');
    var EntitiesBase = require('./entities/base');
    var CartEntities = require('./entities/cart');
    var CustomerEntities = require('./entities/customer');
    var UIUtils = require('./utils/ui');
    var URLUtils = require('./utils/url');
    var DateUtils = require('./utils/dates');
    var StringUtils = require('./utils/strings');
    var DynamicRegion = require('./common/dynamic-region');
    var HeaderDynamicRegion = require('./common/header-control-bar/header-dynamic-region.js');
    var FooterDynamicRegion = require('./common/footer-control-bar/footer-dynamic-region.js');
    var MenuItemExpanded = require('./common/menu/menu-item-expanded');
    var ProductZoomerModal = require('./common/menu/menu-item-expanded/product-zoomer-modal');
    var VideoExpandedModal = require('./common/video-group/video-expanded-modal');
    var Modal = require('./common/modal/modal');
    var LoaderExpanded = require('./common/loader-expanded/loader-expanded');
    var LocationExpandedModal = require('./common/location-display');
    var MegaMenuModal = require('./common/mega-menu-modal');
    var CartExpandedModal = require('./common/cart/cart-expanded-modal');
    var OrderComplete = require('./common/cart/order-complete');
    var SidebarModal = require('./common/sidebar/sidebar-modal');
    var SearchModal = require('./common/search/search-modal');
    var ClickBlockerModal = require('./common/click-blocker-modal');
    var SessionTimoutOverlay = require('./elo-app/session-timeout-overlay');
    var KioskIntroOverlay = require('./elo-app/kiosk-intro-overlay');
    var PageLoading = require('./common/menu/page-loading');
    var Menu = require('./common/menu');
    var FooterControlBar = require('./common/footer-control-bar');
    var HeaderControlBar = require('./common/header-control-bar');
    var HeaderControlBarKiosk = require('./common/header-control-bar-kiosk');
    var EntryFlow = require('./common/entry-flow'); 
    

    var DORMANT_MINUTES = 5;
    var DORMANT_MILLISECONDS = (DORMANT_MINUTES * 60) * 1000;
    // TODO, store in settings..
    var GEOCODER_OPTIONS = {
      key: 'AIzaSyBQeJ_Keec7S3We-bZ0rt4NMytIfBCkCtY'
    };
    var lsCache = require('lscache');
    var Router = Marionette.AppRouter.extend({
        _navigationHistory: null,
        appRoutes: {
            '': 'handleCategoryRoute',
            'products/:productID': 'handleProductRoute',
            ':categorySlug(/:subCategorySlug)(/location/:location)(/brand/:vendor)': 'handleCategoryRoute',
            '*path'  : 'renderPageNotFoundPage'
        }
    });
    var PublicMenuApp = Marionette.Application.extend({
        _searchPanelEnabledForModes: ['kiosk'],
        _filterPanelEnabledForModes: ['menu', 'kiosk'],
        _addToCartEnabledForModes: ['menu', 'embedded'],
        _routerEnabledForModes: ['menu', 'kiosk'],
        _pageLoaderEnabledForModes: ['menu', 'kiosk', 'embedded'],
        _scrollFetchingEnabledForModes: ['menu', 'kiosk'],
        _locationSwitchingEnabledForModes: ['menu', 'embedded'],
        _locationMapEnabledForModes: ['menu'],
        _dormantTimerEnabledForModes: ['kiosk'],
        _navigationHistory: [],
        _menuState: null,
        _settings: null,
        _menuItems: null,
        _initialRoute: true,
        _showingIntro: true,
        _menuItemCategories: null,
        _menuRouter: null,
        _menu: null,
        _appChannel: null,
        _previousQuery: null,
        _fetchingCategoryProductsXHR: null,
        _fetchingProductXHR: null,
        _expandedProductDialog: null,
        _expandedProductDialogLoader: null,
        initialize: function(options) {
            var self = this;

            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }
            self.options = _.defaults(options || {}, {
                instanceId: self.cid,
                sort: 'alpha_asc',
                saleItemsFilterEnabled: false,
                filterVendor: null,
                delivery_method: null,
                menuHomeUrl: null,
                clearanceItemsFilterEnabled: false,
                newItemsFilterEnabled: false,
                thumbStyle: 'thumb', // thumb|full
                menuItemHash: window.location.hash,
                redirectURL: URLUtils.getQueryStringValue('redirect'),
                mode: 'menu', // menu, embedded, slider, kiosk, global
                isUserLoggedIn: false,
                userId: 0,
                multiLocationsSupportEnabled: false,
                reloadOnSessionTimeout: false
            });

            this._settings = new Backbone.Model(farmacy.settings);

            self._appChannel = Backbone.Radio.channel('menu:' + self.options.instanceId);
            self._globalChannel = Backbone.Radio.channel('global');

            self._locations = new LocationEntities.PageableLocationCollection(
                self.options.locations
            );
            
            if (!self.options.filterLocation) {
              var userSavedLocation = LocationEntities.getUserSavedLocation();
              var userSavedLocationExists = false;

              self._locations.each(function (model) {
                if (model.get('slug') === userSavedLocation) {
                  userSavedLocationExists = true;
                }
              })

              if (userSavedLocation !== null && userSavedLocationExists === true) {
                self.options.filterLocation = userSavedLocation;
              } else {
                //TODO: figure out a better way... maybe by IP??
                if (self._locations.findWhere({slug: self._settings.get('defaultLocationSlug')})) {
                  self.options.filterLocation = self._settings.get('defaultLocationSlug');
                } else {
                  self.options.filterLocation = 'hillsidevictoria';
                }
              }
            }

            self._menuItemCategories = new EntitiesBase.CollectionBase(
                self.options.productCategories
            );

            self._vendors = new ProductVendorEntities.PageableProductVendorsCollection(
              self.options.productVendors
            );

            self._menuItemCategories.unshift({
                name: 'All',
                slug: 'all',
                parent_id: 0,
                id: 'all'
            });

            self._menuItems = new MenuProductEntities.PageableMenuProductsCollectionLegacy(
                [],
                {
                    productCategories: self._menuItemCategories
                }
            );

            var slug;
            if (self.options.menuItemHash) {
                slug = self.options.menuItemHash
                    .replace(/^#/, '')
                    .toLowerCase();
            } else {
                slug = self.options.filter.toLowerCase();
            }


            self._menuState = new Backbone.Model({
                menuItems: self._menuItems,
                menuItemCategories: self._menuItemCategories,
                productIDs: self.options.productIDs,
                filterCategorySlugs: self.options.filterCategorySlugs,
                mode: self.options.mode,
                filterSaleItems: self.options.saleItemsFilterEnabled,
                filterNewItems: self.options.newItemsFilterEnabled,
                filterSort: self.options.sort,
                filterVendor: self.options.filterVendor,
                filterClearanceItems: self.options.clearanceItemsFilterEnabled,
                filterLocation: self.options.filterLocation,
                currentPage: 1,
                itemsPerPage: self.calculateNextPageFetchNum(),
                slug: slug,
                sideBarOpen: false,
                retrievingPageData: false,
                displayedProduct: null,
                loadingProduct: false,
                isUserLoggedIn: self.options.isUserLoggedIn,
                userId: self.options.userId,
                multiLocationsSupportEnabled: self.options.multiLocationsSupportEnabled,
                activeViews: new Backbone.Collection([{
                  id: 'thumbs' // thumbs, cartReview, checkoutComplete, productEnlarged, productZoomer, productVideo, sessionTimeoutOverlay, mapLocations
                }])
            });

            self._globalChannel.on('load:category', function (categorySlug, subCategorySlug, options) {
              self._hideMegaMenu();

              if (self.options.mode === 'kiosk') {
                if (options && options.weeklysales === true) {
                  options.filterSaleItems = true;
                  options.filterClearanceItems = true;
                  self._menuState.set('filterSaleItems', true);
                  self._menuState.set('filterClearanceItems', true);
                } else {
                  if (!options) {
                    var options = {};
                  }
                  options.filterSaleItems = false;
                  options.filterClearanceItems = false;
                  self._menuState.set('filterSaleItems', false);
                  self._menuState.set('filterClearanceItems', false);
                }
              }

              if (self.options.mode == 'global') {
                // close mega menu...
                if (window.location.pathname !== '/menu/') {
                  if (!options) {
                    var options = {};
                    options.loadUrl = true;
                  }
                  self.loadCategory(categorySlug, subCategorySlug, options);
                }
              } else {
                // full menu, kiosk... load category...
                if (self.options.mode != 'embedded') {
                  if (options) {
                    options.mode = self.options.mode;
                  } else {
                    var options = {
                      mode: self.options.mode
                    }
                  }
                  self.loadCategory(categorySlug, subCategorySlug, options);
                }
              }
            });

            self._globalChannel.on('location:selected', function (slug, referrer, fromLocationSlug) {
              if (self.options.mode == 'global') {
                var currentFilterLocation = self._menuState.get('filterLocation');
                var requestedFilterLocation = slug;
                var currentLocationCartCount = self._appChannel.request('cart:get:items:count');

                var changeLocation = function (slug) {
                  self._menuState.set('filterLocation', slug);
                  self._globalChannel.trigger(
                      'search:options:changed',
                      {
                          location: slug
                      }
                  );
                  lsCache.set('farmUserSavedLocation',slug, 31556952000);
                  
                  // Trigger an event to notify that the location has been changed
                  self._appChannel.trigger('after:location:changed', slug);
                };


                if (currentFilterLocation == requestedFilterLocation && referrer !== 'temp_closed') {
                  // dont do anything if the same location was selected...
                  return;
                }

                // if its the triggered from the cart move items....
                if (referrer == 'cart') {
                  // move cart items...
                  self._cart.moveCartItemsToLocation (self.options.userId, currentFilterLocation, requestedFilterLocation).then(function (response) {
                    changeLocation(slug);
                    // show cart...
                    self._appChannel.trigger('cart:view');
                  });
                  return;
                }

                // temp closed...
                if (referrer == 'temp_closed') {
                  var fromLocationModel =  self._locations.findWhere({slug: fromLocationSlug});
                  var toLocationModel =  self._locations.findWhere({slug: requestedFilterLocation});
                  if ((parseInt(fromLocationModel.get('temp_closed')) === 1 || fromLocationModel.get('temp_closed') == true)) {
                    self._cart.moveCartItemsToLocation (self.options.userId, currentFilterLocation, requestedFilterLocation).then(function (response) {
                      _.delay(function () {
                        changeLocation(slug);
                        _.delay(function () {

                          self._displayModal({
                            title: 'IMPORTANT INFORMATION!',
                            description: fromLocationModel.get('name') + ' is temporarily closed. You have been transferred to the Hillside Victoria menu. <br><br>Thanks for understanding. Click to close this message.'
                          });
                        }, 500);
                      }, 1500);
                    });
                  }
                  return;
                }

                if (referrer == 'locationSelectEmbedded') {
                  // move cart items...
                  self._cart.moveCartItemsToLocation (self.options.userId, currentFilterLocation, requestedFilterLocation).then(function (response) {
                    changeLocation(slug);
                    window.stop();
                    $(location).prop('href', window.location.protocol + '//' + window.location.hostname + '/' + '/menu/#all/location/' + slug);
                  });
                  return;
                }

                // cart has items in it trigger dialog to see if the customer wants to transfer the items.
                if (currentLocationCartCount && currentLocationCartCount > 0) {
                  self._appChannel.trigger(
                      'show:confirm:dialog',
                      {
                          showCancelButton: true,
                          cancelButtonLabel: 'No, Thanks',
                          confirmText: 'You have ' + currentLocationCartCount + ' item(s) in your cart, did you want to move them to the selected location? Some things may not be in stock at the selected location.',
                          confirmButtonLabel: 'Yes, Please',
                          confirmedCallback: function () {
                            // move cart items...
                            self._cart.moveCartItemsToLocation (self.options.userId, currentFilterLocation, requestedFilterLocation).then(function (response) {
                              changeLocation(slug);
                            });
                          },
                          cancelledCallback: function () {
                            changeLocation(slug);
                          }
                      }
                  );
                } else {
                  // nothing in cart change location...
                  changeLocation(slug);
                }
              } // end if self.options.mode == 'menu'
            });

            self._globalChannel.on('menu:overlay:view:close', function (view) {
              self._appChannel.trigger('menu:overlay:view:close', view);
            });

            self._globalChannel.on('search:options:changed', function (searchOptions) {
              if (self.options.mode == 'menu' || (self.options.mode == 'embedded' && searchOptions.location)) {
                var categorySlug = null;
                if (searchOptions.categorySlug) {
                  categorySlug = searchOptions.categorySlug;
                }

                var subCategorySlug = null;
                if (searchOptions.subCategorySlug) {
                  subCategorySlug = searchOptions.subCategorySlug;
                }

                return self.loadCategory(
                    categorySlug,
                    subCategorySlug,
                    searchOptions
                );
              }
            });

            self._globalChannel.on('active:view:add', function (id) {
              if (id !== 'paymentCart') {
                if (self._cart) {
                  self._cart.clearCardDetails();
                }
              }
              if (id !== 'reviewCart' && id !== 'paymentCart' && id !== 'successCart' && id !== 'challengeCart') {
                self._hideExpandedCart();
              }
              if (id !== 'sidebar') {
                self._hideSideBarMenu();
              }
              self._menuState.get('activeViews').add(new Backbone.Model({
                id: id
              }));

              if (self._menuState.get('activeViews').length > 1) {
                $('body').addClass('fmcy-showing-menu-overlay');
                $('html').addClass('fmcy-showing-menu-overlay');
              }

              self._appChannel.trigger('active:view:updated', self._menuState.get('activeViews'));
            });

            self._globalChannel.on('active:view:remove', function (id) {
              var model = self._menuState.get('activeViews').findWhere({
                id: id
              });
              if (model) {
                self._menuState.get('activeViews').remove(model);
              }
              if (self._menuState.get('activeViews').length === 1) {
                $('body').removeClass('fmcy-showing-menu-overlay');
                $('html').removeClass('fmcy-showing-menu-overlay');
                if ($('body').hasClass('fmcy-product-tile-theme-dark')) {
                  $('body').removeClass('fmcy-product-tile-theme-dark');
                }
              }

              self._appChannel.trigger('active:view:updated', self._menuState.get('activeViews'));
            });

            // local...
            self._appChannel.reply('active:view:check', function (id) {
              var active = false;
              self._menuState.get('activeViews').each(function (model) {
                if (id === model.get('id')) {
                  active = true;
                }
              });
              return active;
            });

            self._appChannel.on('active:view:add', function (id) {
              self._globalChannel.trigger('active:view:add', id);
            });

            self._appChannel.on('active:view:remove', function (id) {
              self._globalChannel.trigger('active:view:remove', id);
            });

            self._appChannel.on('show:login:dialog', function (model) {
              window.jQuery(window.document).trigger('lrm_show_signin');
            });

            self._appChannel.on('show:register:dialog', function (model) {
              window.jQuery(window.document).trigger('lrm_show_register');
            });

            self._appChannel.on('cart:add:item', function (variantModel, menuItemModel) {
              self._globalChannel.trigger(
                  'cart:add:item', variantModel, menuItemModel
              );
            });

            self._appChannel.on('gtag:event', function (eventName, eventObject) {
              // only log this event on production...
              if (window.location.host == 'originalfarm.com') {
                gtag('event', eventName, eventObject);
              }
            });

            self._appChannel.on('gtag:page:view', function (page_title, page_path) {
              if (window.location.host == 'originalfarm.com') {
                gtag('config', 'UA-80125340-1', {
                  'page_path': page_path
                });
                gtag('config', 'G-RQS96HQHRY', {
                  'page_path': page_path
                });
              }
            });

            self._appChannel.reply('get:filter:location', function() {
                return self._menuState.get('filterLocation');
            });

            self._appChannel.reply('get:filter:location:details', function() {
                var currentLocationModel = null;
                self._locations.each(function (location) {
                  if (self._menuState.get('filterLocation') === location.get('slug')) {
                    currentLocationModel = location;
                  }
                });
                if (currentLocationModel === null) {
                  currentLocationModel = self._locations.at(0);
                  self._menuState.set('filterLocation', currentLocationModel.get('slug'));
                }
                return currentLocationModel;
            });

            self._globalChannel.on('filterLocationChanged', function (filterLocation) {
              if (self._menuState.get('filterLocation') !== filterLocation) {
                self._menuState.set('filterLocation', filterLocation);
              }
            });

            self._menuState.on('change:filterLocation', function (model) {
              self._appChannel.trigger('cart:items:updated');
              self._globalChannel.trigger('filterLocationChanged', model.get('filterLocation'));
            });

            self._appChannel.on('menu:sidebar:view', function () {
              if (self._menuState.get('sideBarOpen') == true) {
                self._hideSideBarMenu();
              } else {
                self._displaySideBarMenu({
                  isUserLoggedIn: self.options.isUserLoggedIn
                });
              }
            });

            self._appChannel.on('menu:overlay:view:close', function (except) {
              if (except !== 'sidebar') {
                self._hideSideBarMenu();
              }
              if (except !== 'search') {
                self._hideSearchMenu();
              }
              if (except !== 'megamenu') {
                self._hideMegaMenu();
              }
            });

            self._appChannel.on('show:confirm:dialog', function (options) {
              self._globalChannel.trigger('show:confirm:dialog', options);
            });

            self._appChannel.on('menu:search:view', function (options) {
              self._globalChannel.trigger('menu:search:view', options);
            });

            self._appChannel.on('menu:search:view:close', function () {
              self._globalChannel.trigger('menu:search:view:close');
            });

            self._appChannel.reply('cart:get:delivery:model', function () {
              return self._globalChannel.request('cart:get:delivery:model');
            });

            self._appChannel.reply('validate:address:geocode', function (address) {
              return self._globalChannel.request('validate:address:geocode', address);
            });

            self._appChannel.reply('validate:postal:code:delivery:area', function (postalCode) {
              return self._globalChannel.request('validate:postal:code:delivery:area', postalCode);
            });

            self._appChannel.reply('validate:is:delivery:available:anywhere', function () {
              return self._globalChannel.request('validate:is:delivery:available:anywhere');
            });


            self._appChannel.reply('validate:is:delivery:available:at:this:time', function () {
              return self._globalChannel.request('validate:is:delivery:available:at:this:time');
            });

            self._globalChannel.on('update:favourite', function (productId, isFavourite) {
              var channelName = 'update:favourite:' + productId;
              self._appChannel.trigger(channelName, isFavourite);
            });

            self._customer = null;

            if (self.options.mode == 'global' || self.options.mode == 'kiosk') {
              if (self.options.isUserLoggedIn) {
                self._customer = CustomerEntities.CustomerModel(self.options.userData);
                self._pubsub = new (require('./pubsub'))({
                    subscribeKey: this._settings.get('pubnub').subscribeKey,
                    publishKey: this._settings.get('pubnub').publishKey,
                    uuid: self._customer.get('pubnubuuid')
                });
                self._addPubSubListeners(self._customer.get('orders').get_active_order_channels());

                // set user id in google analytics...
                gtag('config', 'UA-80125340-1', {
                  'user_id': self.options.userId
                });
                gtag('config', 'G-RQS96HQHRY', {
                  'user_id': self.options.userId
                });


              } // end if user logged in...

              new (require('./notifications-manager'))({
                  defaultIconUrl: 'https://farm-email-content.s3-us-west-2.amazonaws.com/common/f_logo_small.png'
              });

              self._appChannel.reply('customer:get:data', function () {
                return self._customer;
              });

              self._cart = CartEntities.Cart({
                userId: self.options.userId,
                cartData: self.options.cartData
              });

              self._appChannel.reply('cart:get:payment:model', function () {
                return self._cart.paymentModel;
              });


              self._globalChannel.reply('toggle:favourite', function (productModel, isFavourite) {
                self._globalChannel.trigger('update:favourite', productModel.get('id'), isFavourite);
                var $deferred = $.Deferred();
                Backbone.Radio.channel('global')
                .request('ajax', 'farmacyajaxv2-favourite-product', {
                    productId: productModel.get('id'),
                    isFavourite: isFavourite
                })
                .success(function(response) {
                  if (response.error == false) {
                    if (isFavourite == true) {
                      self._customer.get('favourite_products').add(response.data);
                    } else {
                      var favModel = self._customer.get('favourite_products').findWhere({'product_id': productModel.get('id')});
                      if (favModel) {
                        self._customer.get('favourite_products').remove(favModel);
                      }
                    }
                  }
                  $deferred.resolve({
                    error: response.error
                  });
                })
                .fail(function(error) {
                  $deferred.resolve({
                    error: true
                  });
                });
                return $deferred.promise();
              });

              self._globalChannel.reply('get:customer:favourites', function () {
                return self._customer.get('favourite_products');
              });

              self._globalChannel.reply('is:favourite', function (productModel) {
                var isFavourite = false;
                var $deferred = $.Deferred();
                if (self._customer && self._customer.get('favourite_products').length) {
                  var favModel = self._customer.get('favourite_products').findWhere({'product_id': productModel.get('id')});
                  if (favModel) {
                    isFavourite = true;
                  }
                }

                $deferred.resolve(isFavourite);
                return $deferred.promise();
              });

              self._globalChannel.reply('cart:get:delivery:model', function () {
                return self._cart.deliveryModel;
              });

              self._globalChannel.reply('validate:is:delivery:available:anywhere', function () {
                  var delivery_available = false;
                  self._locations = self._appChannel.request('get:locations');
                  self._locations.forEach(function (location, index) {
                    if ((parseInt(location.get('delivery_active')) == 1 || location.get('delivery_active') == true) &&
                      (location.get('delivery_area_postal_codes') ||
                      location.get('delivery_area_geojson')) &&
                      (location.get('delivery_area_postal_codes').length > 1 ||
                        location.get('delivery_area_geojson').length > 1)) {
                      delivery_available = true;
                    }
                  });
                  return delivery_available;
              });

              self._globalChannel.reply('validate:is:delivery:available:at:this:time', function () {
                  var delivery_available_at_this_time = true;
                  var delivery_next_available = false;
                  var currentSelectedLocation = self._appChannel.request('get:filter:location:details');                  
                  var isDeliveryAvailableAtCurrentTime = currentSelectedLocation.isDeliveryAvailableAtCurrentTime();
                  if (parseInt(currentSelectedLocation.get('delivery_active')) == 0 ||
                    currentSelectedLocation.get('delivery_active') == false) {
                    delivery_available_at_this_time = false;
                  } else {
                    if (isDeliveryAvailableAtCurrentTime.available == false &&
                      parseInt(currentSelectedLocation.get('delivery_active')) !== 0 &&
                      currentSelectedLocation.get('delivery_active') !== false && 
                      (currentSelectedLocation.get('delivery_area_postal_codes') !== null &&
                        currentSelectedLocation.get('delivery_area_postal_codes') != '') &&
                      farmacy.settings.payments.creditCardPaymentEnabled == true) {
                        delivery_available_at_this_time = false;
                        // check is delivery available in the future....
                        var deliveryNextAvailable = currentSelectedLocation.deliveryNextAvailable();
                        if (deliveryNextAvailable.available) {
                          delivery_next_available = deliveryNextAvailable;
                        }
                    } else {
                      console.log('Delivery is available at current time:', isDeliveryAvailableAtCurrentTime.available);
                    }
                  }
                  
                  var result = {
                    deliveryAvailableAtThisTime: delivery_available_at_this_time,
                    deliveryNextAvailable: delivery_next_available
                  };
                  
                  console.log('Final delivery validation result:', result);
                  return result;
              });

              self._globalChannel.reply('validate:postal:code:delivery:area', function (postalCode) {
                var $deferred = $.Deferred();
                var geocoder = NodeGeocoder(GEOCODER_OPTIONS);
                var withinDeliveryArea = false;
                var withinCurrentFarmLocation = false;
                var withinDeliveryAreaSlug = null;
                var withinDeliveryAreaLocation = null;
                var response = {};

                // check postal code against array of postal codes for location
                self._locations = self._appChannel.request('get:locations');
                self._locations.forEach(function (location, index) {
                  var deliveryAreaPostalCodes = null;
                  if ((parseInt(location.get('delivery_active')) == 1 || location.get('delivery_active') == true) && location.get('delivery_area_postal_codes') && location.get('delivery_area_postal_codes') !== '') {
                    deliveryAreaPostalCodes = location.get('delivery_area_postal_codes');
                  }
                  if (deliveryAreaPostalCodes) {
                    var deliveryAreaPostalCodesArray = deliveryAreaPostalCodes.split(',');
                    var postCodeCompare = postalCode.replace(' ', '').replace(/\W/g, '');
                    
                    deliveryAreaPostalCodesArray.forEach(function (deliveryAreaPostalCode) {
                      if (StringUtils.matchWildCard(postCodeCompare.toLowerCase(), deliveryAreaPostalCode.toLowerCase().replace(' ', ''))) {
                        withinDeliveryArea = true;
                        withinDeliveryAreaSlug = location.get('slug');
                        withinDeliveryAreaLocation = location;
                      }
                    });
                  }
                }); // end locations foreach

                if (withinDeliveryArea == true) {
                  // fire and forget postal code logging
                  self._globalChannel.trigger('save:postal:code:to:log', postalCode, 1);

                  var deliveryAddressModel = self._cart.deliveryModel.get('cartDeliveryAddressModel');
                  deliveryAddressModel.set('local_delivery_postal_code', postalCode);
                  deliveryAddressModel.set('local_delivery_postal_code_verified', postalCode);
                  deliveryAddressModel.set('local_delivery_confirmed_farm_location_slug', withinDeliveryAreaSlug);
                  deliveryAddressModel.set('local_delivery_street_address_geocoded_apartment', null);   
                  deliveryAddressModel.set('local_delivery_street_address_geocoded_city', null);
                  deliveryAddressModel.set('local_delivery_street_address_geocoded_country', null);
                  deliveryAddressModel.set('local_delivery_street_address_geocoded_lat', null);
                  deliveryAddressModel.set('local_delivery_street_address_geocoded_lon', null);
                  deliveryAddressModel.set('local_delivery_street_address_geocoded_postal_code', null);
                  deliveryAddressModel.set('local_delivery_street_address_geocoded_state', null);
                  deliveryAddressModel.set('local_delivery_street_address_geocoded_street_address', null);
                  deliveryAddressModel.set('local_delivery_street_address_geocoded_street_name', null);
                  deliveryAddressModel.set('local_delivery_street_address_geocoded_response', null);
                  deliveryAddressModel.set('local_delivery_street_address_verified', null);   

                  // save the address to local storage...
                  lsCache.set('cartDeliveryAddressModel', deliveryAddressModel.toJSON(), 14400000);
                  
                  $deferred.resolve({
                    error: false,
                    response: {
                      withinDeliveryAreaSlug: withinDeliveryAreaSlug
                    }
                  });
                } else {
                  self._globalChannel.trigger('save:postal:code:to:log', postalCode, 0);
                  self._locations = self._appChannel.request('get:locations');
                  var anyLocationHasGeoJSON = false;
                  self._locations.forEach(function (location, index) {
                    var deliveryAreaGeoJson = null;
                    if ((parseInt(location.get('delivery_active')) == 1 || location.get('delivery_active') == true) && location.get('delivery_area_geojson') && location.get('delivery_area_geojson') !== '') {
                      deliveryAreaGeoJson = JSON.parse(location.get('delivery_area_geojson'));
                    }
                    if (deliveryAreaGeoJson && deliveryAreaGeoJson.features) {
                      anyLocationHasGeoJSON = true;
                    }
                  }); // end locations foreach
                  
                  if (!anyLocationHasGeoJSON) {
                    var deliveryAddressModel = self._cart.deliveryModel.get('cartDeliveryAddressModel');
                    deliveryAddressModel.set('local_delivery_postal_code_verified', false);
                    deliveryAddressModel.set('local_delivery_confirmed_farm_location_slug', null);
                    lsCache.set('cartDeliveryAddressModel', deliveryAddressModel.toJSON(), 14400000);

                    $deferred.resolve({
                      error: true,
                      response: response
                    });
                  } else {
                    // if we get here a location has geojson, geocode...
                    geocoder.find(postalCode, function(err, res){
                      // process response object
                      var error = false;
                      var response = {};

                      if (res && res.length) {
                        var geocode = res[0];
                        // first check if the response is in BC
                        if (geocode.administrative_area_level_1 && geocode.administrative_area_level_1.short_name !== 'BC') {
                          // not BC
                          error = true;
                        } else {
                          //within BC....
                          response = {
                            place_name: null,
                            latLng: null,
                            state: null,
                            postalCode: null,
                            country: 'Canada',
                            city: null,
                            street_address: null,
                            street_name: null,
                            apartment: null
                          }
                          if (geocode.formatted_address) {
                            response.place_name = geocode.formatted_address;
                          }
                          if (geocode.location) {
                            response.latLng = [geocode.location.lat, geocode.location.lng];
                          }
                          if (geocode.administrative_area_level_1) {
                            response.state = geocode.administrative_area_level_1.long_name;
                          }
                          if (geocode.postal_code) {
                            response.postalCode = geocode.postal_code.long_name;
                          }
                          if (geocode.city) {
                            response.city = geocode.city.long_name;
                          }
                          if (geocode.street_number) {
                            response.street_address = geocode.street_number.long_name;
                          }
                          if (geocode.route) {
                            response.street_name = geocode.route.short_name;
                          }
                          if (geocode.subpremise) {
                            response.apartment = geocode.subpremise.long_name;
                          }

                          if (response.latLng == null) {
                            error = true;
                          }
                        }
                      } else {
                        error = true;
                      }
                      if (error) {
                        $deferred.resolve({
                          error: true,
                          response: response
                        });
                      } else {

                        var points = turf.points([[
                          response.latLng[1], response.latLng[0]
                        ]]);
                       
                        
                        self._locations.forEach(function (location, index) {
                          var deliveryAreaGeoJson = null;
                          if ((parseInt(location.get('delivery_active')) == 1 || location.get('delivery_active') == true) && location.get('delivery_area_geojson') && location.get('delivery_area_geojson') !== '') {
                            deliveryAreaGeoJson = JSON.parse(location.get('delivery_area_geojson'));
                          }
                          if (deliveryAreaGeoJson && deliveryAreaGeoJson.features) {
                            deliveryAreaGeoJson.features.forEach(function (feature, index) {
                              var searchWithin = turf.polygon(feature.geometry.coordinates);
                              var ptsWithin = turf.pointsWithinPolygon(points, searchWithin);
                              if (ptsWithin.features.length > 0) {
                                withinDeliveryArea = true;
                                withinDeliveryAreaSlug = location.get('slug');
                                withinDeliveryAreaLocation = location;
                              }
                            });
                          }
                        }); // end locations foreach


                        if (withinDeliveryArea == true) {
                          var deliveryAddressModel = self._cart.deliveryModel.get('cartDeliveryAddressModel');
                          deliveryAddressModel.set('local_delivery_postal_code', postalCode);
                          deliveryAddressModel.set('local_delivery_street_address_geocoded_lat', response.latLng[0]);
                          deliveryAddressModel.set('local_delivery_street_address_geocoded_lon', response.latLng[1]);
                          deliveryAddressModel.set('local_delivery_street_address_geocoded_response', response.place_name);
                          deliveryAddressModel.set('local_delivery_street_address_geocoded_state', response.state);
                          deliveryAddressModel.set('local_delivery_street_address_geocoded_postal_code', response.postalCode);
                          deliveryAddressModel.set('local_delivery_street_address_geocoded_country', response.country);
                          deliveryAddressModel.set('local_delivery_street_address_geocoded_city', response.city);
                          deliveryAddressModel.set('local_delivery_postal_code_verified', postalCode);
                          deliveryAddressModel.set('local_delivery_confirmed_farm_location_slug', withinDeliveryAreaSlug);


                          deliveryAddressModel.set('local_delivery_street_address', null);
                          deliveryAddressModel.set('local_delivery_street_address_geocoded_street_name', null);
                          deliveryAddressModel.set('local_delivery_street_address_geocoded_street_address', null);
                          deliveryAddressModel.set('local_delivery_street_address_geocoded_apartment', null);
                          deliveryAddressModel.set('local_delivery_street_address_verified', false);

                          // save the address to local storage...
                          lsCache.set('cartDeliveryAddressModel', deliveryAddressModel.toJSON(), 14400000);

                          $deferred.resolve({
                            error: false,
                            response: {
                              withinDeliveryAreaSlug: withinDeliveryAreaSlug
                            }
                          });

                        } else {

                          var deliveryAddressModel = self._cart.deliveryModel.get('cartDeliveryAddressModel');
                          deliveryAddressModel.set('local_delivery_postal_code_verified', false);
                          deliveryAddressModel.set('local_delivery_confirmed_farm_location_slug', null);
                          lsCache.set('cartDeliveryAddressModel', deliveryAddressModel.toJSON(), 14400000);

                          $deferred.resolve({
                            error: true,
                            response: response
                          });

                        }
                      } //end if else error
                    }); // end geocode
                  }
                }

                return $deferred.promise();
              });

              self._globalChannel.reply('validate:address:geocode', function (address) {
                var $deferred = $.Deferred();
                var geocoder = NodeGeocoder(GEOCODER_OPTIONS);
                geocoder.find(address, function(err, res){
                  // process response object
                  var error = false;
                  var response = {};
                  if (res.length) {
                    var geocode = res[0]
                    // first check if the response is in BC
                    if (geocode.administrative_area_level_1 && geocode.administrative_area_level_1.short_name !== 'BC') {
                      // not BC
                      error = true;
                    } else {
                      //within BC....
                      response = {
                        place_name: null,
                        latLng: null,
                        state: null,
                        postalCode: null,
                        country: 'Canada',
                        city: null,
                        street_address: null,
                        street_name: null,
                        apartment: null
                      }
                      if (geocode.formatted_address) {
                        response.place_name = geocode.formatted_address;
                      }
                      if (geocode.location) {
                        response.latLng = [geocode.location.lat, geocode.location.lng];
                      }
                      if (geocode.administrative_area_level_1) {
                        response.state = geocode.administrative_area_level_1.long_name;
                      }
                      if (geocode.postal_code) {
                        response.postalCode = geocode.postal_code.long_name;
                      }
                      if (geocode.city) {
                        response.city = geocode.city.long_name;
                      }
                      if (geocode.street_number) {
                        response.street_address = geocode.street_number.long_name;
                      }
                      if (geocode.route) {
                        response.street_name = geocode.route.short_name;
                      }
                      if (geocode.subpremise) {
                        response.apartment = geocode.subpremise.long_name;
                      }

                      if (response.street_address == null ||
                        response.street_name == null ||
                        response.city == null ||
                        response.latLng == null
                      ) {
                        error = true;
                      }
                    }
                  } else {
                    error = true;
                  }
                  if (error) {
                    $deferred.resolve({
                      error: true,
                      response: response
                    });
                  } else {
                    $deferred.resolve({
                      error: false,
                      response: response
                    });
                  }
                });
                return $deferred.promise();
              });

              self._globalChannel.on('save:postal:code:to:log', function (postalCode, withinDeliveryArea) {
                  if (self._settings && self._settings.get('aws') && self._settings.get('aws').api_url) {
                      var url = self._settings.get('aws').api_url + 'postalcode';
                      var headers = {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      };
                      $.ajax({
                        url: url,
                        type: 'POST',
                        data: JSON.stringify({ 
                          postalCode: postalCode, 
                          existsWithinDeliveryArea: withinDeliveryArea
                        }),
                        headers: headers,
                        contentType: 'application/json',
                        dataType: 'json'
                      })
                  }
              });

              self._appChannel.reply('cart:get:payment:method:model', function () {
                // TODO, make this a function and get the correct model based on payment method...
                return self._cart.paymentModel.get('paymentCreditCardModel');
              });

              self._appChannel.on('cart:set:payment:method', function (paymentMethod) {
                self._cart.paymentModel.set('paymentMethod', paymentMethod);
              });

              self._appChannel.on('cart:set:delivery:method', function (deliveryMethod) {
                self._cart.deliveryModel.set('deliveryMethod', deliveryMethod);
              });
              
              self._appChannel.on('cart:remove:item', function (model) {
                var cartItem = self._cart.findWhere({
                  variant_id: model.get('variant_id'), 
                  location: model.get('location'),
                  user_id: model.get('user_id')
                });

                if (cartItem) {
                  self._cart.remove(cartItem, {silent: true});
                  cartItem.trigger('destroy', cartItem);
                }

                self._appChannel.trigger('cart:items:updated');
              });

              self._globalChannel.on('member:joined:club', function () {
                if (self._customer) {
                  self._customer.set('is_club_member', '1');
                }
              });

              self._globalChannel.on('member:name:updated', function (model) {
                if (self._customer) {
                  self._customer.set('first_name', model.get('first_name'));
                  self._customer.set('last_name', model.get('last_name'));
                  self._customer.set('display_name', model.get('first_name') + ' ' + model.get('last_name'));
                }
              });

              self._globalChannel.reply('order:cancel', function(model) {
                  return self._customer.get('orders').cancel_order(model);
              });

              self._globalChannel.reply('get:navigation:history', function() {
                  return self._navigationHistory;
              });

              self._globalChannel.on('add:navigation:history:entry', function (entry) {
                if (self._navigationHistory) {
                  if (self._navigationHistory.length == 0 || self._navigationHistory[self._navigationHistory.length - 1].fragment !== entry.fragment) {
                    self._navigationHistory.push(entry);
                    self._appChannel.trigger('gtag:page:view', '', window.location.pathname + '#' + entry.fragment);
                  }
                }
              });

              self._globalChannel.on('menu:search:view', function (options) {
                if (self._menuState.get('searchOpen') == true) {
                  self._hideSearchMenu();
                } else {
                  self._displaySearchMenu(_.extend(options, {
                    isUserLoggedIn: self.options.isUserLoggedIn
                  }));
                }
              });

              self._globalChannel.reply('load:product', function (productSlug, productId, productModel) {
                  return self.loadProduct(productSlug, productId, productModel);
              });

              self._globalChannel.on('menu:search:view:close', function () {
                if (self._menuState.get('searchOpen') == true) {
                  self._hideSearchMenu();
                }
              });

              self._globalChannel.on('cart:add:item', function (variantModel, menuItemModel) {
                if (!self._menuState.get('isUserLoggedIn')) {
                  self._appChannel.trigger('show:login:dialog');
                  return;
                }
                self._cart.addCartItem(self._menuState.get('filterLocation'), self.options.userId, variantModel, menuItemModel);
                self._appChannel.trigger('cart:items:update:subtotals');
                self._appChannel.trigger('cart:items:updated');
                return self._cart;
              });

              self._appChannel.on('cart:items:update:subtotals', function () {
                self._cart.updateSubTotals(self._menuState.get('filterLocation'), self.options.userId);
              });

              self._appChannel.reply('cart:get:items', function () {
                return self._cart.itemsByUserLocation(self._menuState.get('filterLocation'), self.options.userId);
              });

              self._appChannel.reply('cart:get:items:count', function () {
                return self._cart.totalCountByUserLocation(self._menuState.get('filterLocation'), self.options.userId);
              });

              self._appChannel.reply('cart:get:curent:order', function () {
                return self._cart.paymentModel.get('currentOrder');
              });

              self._appChannel.reply('cart:get:total:cost', function () {
                var filteredLocationDetails = self._appChannel.request('get:filter:location:details');
                return self._cart.totalCostByUserLocation(self.options.userId, self._menuState.get('filterLocation'), filteredLocationDetails);
              });

              self._appChannel.reply('cart:get:total:weight', function () {
                return self._cart.totalCartWeight({
                  filterLocation: self._menuState.get('filterLocation'),
                  userId: self.options.userId
                });
              });

              self._appChannel.reply('cart:validate:prices', function () {
                return self._cart.checkCartItemsForPriceChanges(self._menuState.get('filterLocation'), self.options.userId);
              });

              self._appChannel.on('cart:pay', function () {
                self._displayClickBlocker();

                self._locations.fetch().then(function () {
                  var filteredLocationDetails = self._appChannel.request('get:filter:location:details');
                  // validate cart once more before paying if they left the payment view open for awhile...
                  self._cart.validateCartContents(self.options.userId, self._menuState.get('filterLocation'), filteredLocationDetails).then(function (response) {
                    if (response.errors && response.errors.length > 0) {
                      // errors go back a step....
                      self._displayExpandedCart({
                        errors: response.errors
                      });
                      self._hideClickBlocker();
                    } else {
                      // no errors... lets pay.
                      var creditCardModelValidationFields = self._cart.paymentModel.get('paymentCreditCardModel').validationFields();
                      var cartValid = self._cart.paymentModel.get('paymentCreditCardModel').isValid(creditCardModelValidationFields);
                      if (cartValid) {
                        self._orderPay();
                      } else {
                        self._hideClickBlocker();
                        self._appChannel.trigger('cart:display:errors');
                      }
                    }
                  });
                });
              }); // end cart:pay

              self._appChannel.on('cart:close', function () {
                self._hideExpandedCart();
              });

              self._appChannel.on('cart:validate', function () {
                self._displayClickBlocker();

                if (farmacy.settings.giftEnabled) {
                  //check gift form is valid...
                  var giftModelValidationFields = self._cart.paymentModel.get('cartGiftModel').validationFields();
                  var shouldValidateGiftForm = self._cart.paymentModel.get('cartGiftModel').shouldValidateGiftForm();
                  if (shouldValidateGiftForm) {
                    var giftFormValid = self._cart.paymentModel.get('cartGiftModel').isValid(giftModelValidationFields);
                    if (giftFormValid == false) {
                      self._displayExpandedCart({
                        errorMessage: 'Please review the gift form below:',
                        errors: [
                          {
                            code: 'giftform',
                          }
                        ]
                      });
                      self._hideClickBlocker();
                      return;
                    }
                  }
                }

                // double check cart prices in the case someone has left the cart open overnight and the prices have changed...
                self._appChannel.request('cart:validate:prices').then(function (response) {
                  if (response.changeCount > 0) {
                    // priced have changed, so cart and error message...
                    self._displayExpandedCart({
                      errorMessage: 'Some prices have changed. Please review.',
                      errors: [
                        {
                          code: 'pricechanges',
                        }
                      ]
                    });
                    self._hideClickBlocker();
                  } else {

                    self._locations.fetch().then(function () {
                      var filteredLocationDetails = self._appChannel.request('get:filter:location:details');
                      self._cart.validateCartContents(self.options.userId, self._menuState.get('filterLocation'), filteredLocationDetails).then(function (response) {
                        if (response.errors && response.errors.length > 0) {
                          self._displayExpandedCart({
                            errors: response.errors
                          });
                          self._hideClickBlocker();
                        } else {
                          self._submitOrder();
                        }
                      }).fail(function (response) {
                        console.log(response);
                      });// end cart _cart.validateCartContents
                    }).fail(function (response) {
                      self._displayExpandedCart({
                        errorMessage: 'Problem, please try again.',
                        errors: [
                          {
                            code: 'fetcherror',
                          }
                        ]
                      });
                      self._hideClickBlocker();
                    }); // end locations fetch  
                  } // end no price change count...
                });
              });

              self._appChannel.on('cart:view', function () {
                if (!self._menuState.get('isUserLoggedIn')) {
                  self._appChannel.trigger('show:login:dialog');
                  return;
                }
                self._displayExpandedCart();
              });

              self._appChannel.on('location:selection:view', function (options) {
                self._displayEntryDialog(options);
                //self._displayExpandedLocationSelection(options);
              });

              self._globalChannel.on('location:selection:view', function (options) {
                //self._displayExpandedLocationSelection(options);
                self._displayEntryDialog(options);
              });

              self._globalChannel.on('display:mega:menu', function (options) {
                self._displayMegaMenu(options);
              });
            } // end if global...

            self._appChannel.on('display:mega:menu', function (options) {
              return self._globalChannel.trigger('display:mega:menu', options);
            });

            self._appChannel.reply('order:cancel', function(model) {
                return self._customer.get('orders').cancel_order(model);
            });

            self._appChannel.reply('order:update:status', function(order) {
                var model = self._customer.get('orders').update_status(order.order_id, order.order_status, order.order_payment_status);
                self._appChannel.trigger('orders:updated');
                return model;
            });

            self._appChannel.reply('orders:ready:count', function() {
                if (self._customer !== null) {
                  return self._customer.get('orders').get_ready_count();
                } else {
                  return 0;
                }
            });

            self._appChannel.reply('is:user:logged:in', function() {
                return self._menuState.get('isUserLoggedIn');
            });

            self._appChannel.reply('get:locations', function() {
                return self._locations;
            });

            self._appChannel.reply('get:vendors', function() {
                return self._vendors;
            });

            self._appChannel.reply('get:filter:vendor', function() {
                return self._menuState.get('filterVendor');
            });

            self._appChannel.reply('get:navigation:history', function() {
                  return self._globalChannel.request('get:navigation:history');
            });

            self._appChannel.reply('scroll:to:page:top', function() {
                if (self._appChannel.request('active:view:check', 'paymentCart')) {
                  UIUtils.scrollToPageTop(self._expandedCartModal.$el);
                } else {
                  UIUtils.scrollToPageTop();
                }
            });

            self._appChannel.reply('load:category', function (categorySlug, subCategorySlug, options) {
                if (options && options.mode && options.mode === 'embedded') {
                  self.loadCategory(categorySlug, subCategorySlug, options);
                } else {
                  self._globalChannel.trigger('load:category', categorySlug, subCategorySlug, options);
                }
            });
            self._appChannel.reply('load:product', function (productSlug, productId, productModel) {
                return self.loadProduct(productSlug, productId, productModel);
            });

            self._appChannel.reply('load:product:url', function (productSlug) {
              if (!window.location.origin) {
                window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
              }
              var productURL = window.location.origin + '/menu/' + '#products/' + productSlug;
              try {
                  window.stop();
              } catch (exception) {
                  document.execCommand('Stop');
              }
              $(location).prop('href', productURL);
              return;
            });

            self._appChannel.reply('load:product:zoomer', function (product) {
                return self._displayProductZoomer(product);
            });

            self._appChannel.reply('load:enlarged:video', function (video, collection) {
                return self._displayEnlargedVideo(video, collection);
            });

            self._appChannel.on('search:options:changed', function (searchOptions) {
              self._globalChannel.trigger('search:options:changed', searchOptions);
            });

            self._appChannel.on('location:selected', function (slug, referrer) {
              self._globalChannel.trigger('location:selected', slug, referrer);
            });

            self._appChannel.on('age:yes:clicked', function () {
              var serverUnixTime = self._serverUnixTime();
              var lastAgeGateYesClickedTime = lsCache.get('lastAgeGateYesClickedTime');
              var serverDateTimeString = DateUtils.getFormattedTimestamp(serverUnixTime, {
                  format: 'YYYY-MM-DD H:mmA'
              });
              var endOfDayUnixTime = moment(serverDateTimeString, 'YYYY-MM-DD H:mmA').endOf('day').unix();
              var secondsToMidnight = ((endOfDayUnixTime - serverUnixTime) / 60);

              // expire this cache at midnight, which will show the modal.
              lsCache.set('lastAgeGateYesClickedTime',serverUnixTime, secondsToMidnight);
            });

            self._appChannel.reply('toggle:favourite', function (productModel, isFavourite) {
              return self._globalChannel.request('toggle:favourite', productModel, isFavourite);
            });

            self._appChannel.reply('is:favourite', function (productModel) {
              return self._globalChannel.request('is:favourite', productModel);
            });

            self._appChannel.reply('navigate:to', function (fragment, options) {

                self._globalChannel.trigger('add:navigation:history:entry', {
                    name: '',
                    args: fragment.split('/'),
                    fragment: fragment
                });

                if (self.shouldRoutingBeEnabled() && self._menuRouter) {
                    if (self.shouldDormantTimerBeEnabled()) {
                      self._resetDormantTimer();
                    }
                    self._menuRouter.navigate(fragment, options);
                }
            });

            self._appChannel.on('kiosk:show:intro', function () {
              self._showIntro();
            });

            // Helper for making ajax calls (provides all the necessary security info)
            // TODO: leaving global for the moment, but should change potentially if we have any collisions...
            Backbone.Radio.channel('global').reply('ajax', function (action, params) {
                return jQuery.post(
                    FarmacyPluginAjax.ajaxurl,
                        _.extend(
                            {},
                            params,
                            {
                                action: action,
                                security: FarmacyPluginAjax.FarmacyNonce
                            }
                        ),
                        function onPostSuccess (data, status, xhr) {
                            var nonce = xhr.getResponseHeader('X-WP-FarmacyNonce');
                            if (nonce) {
                                console.log('new nonce passed: ' + nonce);
                                FarmacyPluginAjax.FarmacyNonce = nonce;
                            }
                        }
                );
            });

            self.addRegions({
                mainRegion: '#farmacy-menu-' + self.options.instanceId,
                overlayRegion: '#farmacy-menu-overlay-' + self.options.instanceId
            });


            if (self.options.mode === 'global') {
              self._displayFooterControlBar();
              self._displayHeaderControlBar();
              self._setupDialog();
              self._maybeDisplayEntryDialog();
            }

            if (self.options.mode === 'kiosk') {
              self._displayKioskControlBar();
            }

            self._addGlobalAjaxErrorHandler();
            if (self.options.mode == 'global') {
              self._checkLocationtTempClosed(self.options.filterLocation);
            }
        },
        _checkLocationtTempClosed: function (locationSlug, routing) {
          var self = this;
          var currentLocationModel = self._locations.findWhere({slug: locationSlug});
          if (currentLocationModel && (parseInt(currentLocationModel.get('temp_closed')) === 1 || currentLocationModel.get('temp_closed') == true)) {
            var fallbackLocation = 'hillsidevictoria';
            self._globalChannel.trigger('location:selected', fallbackLocation, 'temp_closed', currentLocationModel.get('slug'));
            return fallbackLocation;
          } else {
            return false;
          }
        },
        _addPubSubListeners: function (channels) {
            var self = this;
            if (typeof unsubscribeCallback === 'function') {
              unsubscribeCallback();
            }
            var unsubscribeCallback = Backbone.Radio.channel('pubsub').request(
                'subscribe',
                channels,
                {
                    notificationsHandler: {
                        message: function (resp) {
                            if (!resp || !resp.message || !resp.message.eventName) {
                                return;
                            }
                            switch (resp.message.eventName) {
                                case 'order:status:updated':
                                    var order = resp.message.order;
                                    var updatedModel = self._appChannel.request('order:update:status', order);
                                    if (updatedModel && updatedModel.get('order_status') == 'ready') {
                                      if (updatedModel.get('order_delivery_method') == 'pickup') {
                                        // send notification to browser if its pickup.
                                        Backbone.Radio.channel('global').request(
                                            'show:notification',
                                            'Order ' + updatedModel.get('order_code') + ' is ready for pickup.',
                                            {
                                                onClickedCallback: function () {
                                                  // goto order on click eventually...
                                                }
                                            }
                                        );
                                      }
                                    }
                                    Backbone.Radio.channel('global').trigger(
                                        'order:updated',
                                        updatedModel
                                    );
                                break;
                            }
                        }
                    }
                }
            );

            this.on('destroy', function () {
                unsubscribeCallback();
            });
        },
        _orderSubmitted: function (orderId, order) {
          var self = this;
          var filteredLocationDetails = self._appChannel.request('get:filter:location:details');
          var cartCost = self._cart.totalCostByUserLocation(self.options.userId, self._menuState.get('filterLocation'), filteredLocationDetails);
          var cartItems = self._cart.itemsByUserLocation(self._menuState.get('filterLocation'), self.options.userId);

          var gtagItemArray = [];
          cartItems.each(function (model) {
            gtagItemArray.push({
              id: model.get('id_pos'),
              name: model.get('title'),
              brand: model.get('vendor_name'),
              quantity: model.get('cartCount'),
              price: model.get('price')
            })
          });

          // clear cart
          self._cart.clearCartByLocation(self._menuState.get('filterLocation'), self.options.userId);
          self._cart.saveCartToDatabase(self.options.userId);
          self._appChannel.trigger('cart:items:updated');

          // show success state...
          self._displayExpandedCart({
            state: 'success',
            orderId: orderId,
            order: order,
            _appChannel: self._appChannel
          });

          self._appChannel.trigger('active:view:add','successCart');

          self._hideClickBlocker();

          self._appChannel.trigger('gtag:event', 'purchase', {
            'transaction_id': orderId,
            "affiliation": self._menuState.get('filterLocation'),
            'value': parseFloat(cartCost.total),
            'currency': 'CAD',
            'tax': parseFloat(cartCost.tax),
            'items': gtagItemArray
          });

          self._appChannel.trigger('gtag:event', 'Ordered Created', {
            'event_category': 'User',
            'event_label': 'Ordered Created',
            'value': parseFloat(cartCost.subTotal)
          });
        },
        _orderPay: function () {
          var self = this;
          self._cart.payOrder({
            _appChannel: self._appChannel,
            filterLocation: self._menuState.get('filterLocation')
          }).then(function (response) {
            if (response.error == false) {
              if (response.message && response.message.order_id) {
                var updatedModel = self._appChannel.request('order:update:status', response.message);
                self._orderSubmitted(response.message.order_id, response.message);
              } else {
                self._displayChallengeModal(response);
              }
            } else {
              self._expandedCartChangeState({
                state: 'payment',
                _appChannel: self._appChannel,
                errorMessage: response.message,
                errorField: response.errorField,
                errors: [
                  {
                    code: 'paymentfailed',
                  }
                ]
              });
              self._hideClickBlocker();
            }
          }).fail(function (response) {
            self._expandedCartChangeState({
              state: 'payment',
              _appChannel: self._appChannel,
              errorMessage: 'Payment failed',
              errorField: 'cc_number',
              errors: [
                {
                  code: 'paymentfailed',
                }
              ]
            });
          });
        },
        _displayChallengeModal: function (response) {
          var self = this;
          
          // setup websocket listener for challenge response...
          var _unsubscribeChallengeCallback = Backbone.Radio.channel('pubsub').request(
              'subscribe',
              'orders.' + self._cart.paymentModel.get('currentOrder').get('order_unique_id'), {
                notificationsHandler: {
                    message: function (resp) {
                        if (!resp || !resp.message || !resp.message.eventName) {
                            return;
                        }
                        switch (resp.message.eventName) {
                            case 'challenge:response':
                                if (resp.message.response && resp.message.response.error == false) {
                                  // success...
                                  var order = JSON.parse(resp.message.response.order);
                                  var orderModel = new CustomerEntities.OrderModel(order);
                                  if (self._customer.get('orders').check_exists(orderModel.get('order_id'))) {
                                    self._customer.get('orders').remove_by_order_id(orderModel.get('order_id'));
                                  }
                                  self._customer.get('orders').unshift(orderModel);
                                  self._orderSubmitted(order.order_id, order);
                                } else {
                                  self._expandedCartChangeState({
                                    state: 'payment',
                                    _appChannel: self._appChannel,
                                    errorMessage: resp.message.response.message,
                                    errorField: 'cc_number',
                                    errors: [
                                      {
                                        code: 'paymentfailed',
                                      }
                                    ]
                                  });
                                }
                            break;
                        }
                    }
                }
              }
          );

          // show challenge state...
          self._displayExpandedCart({
            state: 'challenge',
            showCloseButton: false,
            challengeData: response,
            _appChannel: self._appChannel
          });
        
          self._appChannel.trigger('active:view:add','challengeCart');
          self._hideClickBlocker();
        },
        _submitOrder: function () {
          var self = this;

          var filteredLocationDetails = self._appChannel.request('get:filter:location:details');

          self._cart.submitOrder(self.options.userId, self._menuState.get('filterLocation'), filteredLocationDetails).then(function (response) {
            self._hideClickBlocker();
            if (response.error === false && response.message.order_id !== null) {
              var orderModel = new CustomerEntities.OrderModel(response.message);
              // if it exists remove
              if (self._customer.get('orders').check_exists(orderModel.get('order_id'))) {
                self._customer.get('orders').remove_by_order_id(orderModel.get('order_id'));
              }
              self._customer.get('orders').unshift(orderModel);

              self._addPubSubListeners(self._customer.get('orders').get_active_order_channels());
              if (self._cart.paymentModel.get('paymentMethod') == 'instore') {
                self._orderSubmitted(response.message.order_id, response.message);
              } else {
                self._setCurrentOrderAndDisplayPaymentView(orderModel);
              }
            } else {
              self._displayExpandedCart({
                errorMessage: response.message,
                errors: [
                  {
                    code: 'tomanyopenorders',
                  }
                ]
              });
              self._hideClickBlocker();
            }
          }).fail(function (response) {
            // failed... should do something...
          });
        },
        _setCurrentOrderAndDisplayPaymentView: function (model) {
          this._cart.paymentModel.set('currentOrder', model);
          this._cart.paymentModel.set('paymentMethod', model.get('order_payment_method'));

          // need to set gift model if its set...
          this._expandedCartChangeState({
            state: 'payment',
            _appChannel: this._appChannel
          });
          this._hideClickBlocker();
        },
        shouldRoutingBeEnabled: function () {
            return this._routerEnabledForModes.indexOf(this.options.mode) !== -1;
        },
        shouldSearchPanelBeEnabled: function () {
            return this._searchPanelEnabledForModes.indexOf(this.options.mode) !== -1;
        },
        shouldFilterPanelBeEnabled: function () {
            return this._filterPanelEnabledForModes.indexOf(this.options.mode) !== -1;
        },
        shouldAddToCartBeEnabled: function () {
            return this._addToCartEnabledForModes.indexOf(this.options.mode) !== -1;
        },
        shouldPageLoaderBeEnabled: function () {
            return this._pageLoaderEnabledForModes.indexOf(this.options.mode) !== -1;
        },
        shouldScrollFetchingBeEnabled: function () {
            return this._scrollFetchingEnabledForModes.indexOf(this.options.mode) !== -1;
        },
        shouldLocationSwitchingBeEnabled: function () {
            return this._locationSwitchingEnabledForModes.indexOf(this.options.mode) !== -1;
        },
        shouldLocationMapBeEnabled: function () {
            return this._locationMapEnabledForModes.indexOf(this.options.mode) !== -1;
        },
        shouldDormantTimerBeEnabled: function () {
            return this._dormantTimerEnabledForModes.indexOf(this.options.mode) !== -1;
        },
        onStart: function() {
            var self = this;
            if (self.shouldRoutingBeEnabled()) {
                self.setupRouter();
            } else {
                self.loadCategory('all');
            }
            if (this.shouldPageLoaderBeEnabled()) {
              this._renderPageLoader();
              if (self.shouldDormantTimerBeEnabled()) {
                $(window).scroll(function () {
                    self._resetDormantTimer();
                });
                $(window).on('mousemove', function(e) {
                    self._resetDormantTimer();
                });
              }
            }
        },
        _initializeDormantTimer: function () {
          this._startDormantTimer();
        },
        _clearDormantTimer: function () {
          clearTimeout(this.dormantTimer);
          self.dormantTimer = null;
        },
        _resetDormantTimer: function () {
          clearTimeout(this.dormantTimer);
          this.dormantTimer = null;
          this._startDormantTimer();
        },
        _startDormantTimer: function () {
          var self = this;
          this.dormantTimer = _.delay(function () {
            clearTimeout(self.dormantTimer);
            self.dormantTimer = null;
            self._displaySessionTimoutOverlay();
          }, DORMANT_MILLISECONDS);
        },
        calculateNextPageFetchNum: function() {
            if (
                this.options.mode == 'embedded' ||
                this.options.mode == 'slider'
            ) {
                // TODO, try this...
                return 100;
            }
            if (UIUtils.isAccessoriesKioskWidth() && UIUtils.isAccessoriesKioskHeight()) {
              return 20;
            } else if (UIUtils.isPhone()) {
                return 4; // 1 column 4 rows
            } else if (UIUtils.isTablet()) {
                return 8; // 2 columns 4 rows
            } else if (UIUtils.isDesktop() || UIUtils.isLargeDesktop()) {
                return 12; // 3 columns 4 rows
            } else {
                return 16; // 4 columns 4 rows
            }
        },
        _renderMenuItems: function() {
            var self = this;
            if (self._menu && self._menu.isRendered) {
                return self._menu;
            }
            self._menu = new Menu({
                appChannel: self._appChannel,
                model: self._menuState,
                mode: self.options.mode,
                thumbStyle: self.options.thumbStyle,
                searchPanelEnabled: self.shouldSearchPanelBeEnabled(),
                filterPanelEnabled: self.shouldFilterPanelBeEnabled(),
                scrollFetchingEnabled: self.shouldScrollFetchingBeEnabled(),
                locationMapEnabled: self.shouldLocationMapBeEnabled(),
                locationSwitchingEnabled: self.shouldLocationSwitchingBeEnabled(),
                shouldEnableOnlinePurhaseCallback: self._shouldEnableOnlinePurchaseForProduct.bind(self),
                redirectURL: self.options.redirectURL
            });

            self._menu.on('next:page', function() {
                self.getNextPageData();
            });

            self.mainRegion.show(self._menu);
            $(document.body).addClass('fmcy-showing-menu');
            return self._menu;
        },
        _renderPageLoader: function() {
            var pageLoadingDisplayViewRegion = new Marionette.Region({
                el: '#farmacy-footer-message-region'
            });

            if (this.options.mode === 'kiosk') {
              pageLoadingDisplayViewRegion.show(new PageLoading({
                  model: this._menuState,
                  backgroundColor: '#000000',
                  theme: 'dark'
              }));
            } else {
              pageLoadingDisplayViewRegion.show(new PageLoading({
                  model: this._menuState
              }));
            }

        },
        loadProduct: function (productSlug, productId, productModel) {
            var self = this;
            self._hideExpandedProduct();
            self._displayExpandedProductLoader(productModel);
            self._menuState.set('loadingProduct', true);
            function displayProduct (model) {
                self._menuState.set('loadingProduct', false);
                self._displayExpandedProduct(productModel);
                if (!model) {
                    return;
                }

                self._appChannel.trigger(
                    'product:loaded',
                    model
                );

                self._appChannel.request('navigate:to', 'products/' + model.get('slug'));
            }

            if (productModel) {
                displayProduct(productModel);
            } else {
                if (self._fetchingProductXHR && typeof self._fetchingProductXHR.abort === 'function') {
                    self._fetchingProductXHR.abort();
                    self._fetchingProductXHR = null;
                }

                self._menuState.set('retrievingPageData', true);
                productModel = new MenuProductEntities.MenuProductModelLegacy(
                    {},
                    {
                        productCategories: self._menuItemCategories,

                    }
                );

                var fetchParams = {
                  remove_out_stock_variation: false,
                  customer_ordering: true
                };
                if (productId) {
                  fetchParams.product_ids = productId;
                } else {
                  fetchParams.product_slug = productSlug;
                }
                
                fetchParams.filter_location = self._appChannel.request('get:filter:location');

                fetchParams.display_even_if_no_stock_at_location = true;


                self._fetchingProductXHR = productModel.fetch({
                    data: fetchParams
                }).then(function (response) {
                  self._menuState.set('retrievingPageData', false);
                  self._menuState.set('loadingProduct', false);
                  if (_.isArray(response) && response.length) {
                      self._menuItems.add(productModel, { merge: true });
                      displayProduct(productModel);
                  } else {
                      self._hideExpandedProductLoader();
                      self._displayModal();
                  }
                }).fail(function () {
                  self._menuState.set('retrievingPageData', false);
                  self._menuState.set('loadingProduct', false);
                });
            }
        },
        loadCategory: function (categorySlug, subCategorySlug, options) {
            var self = this;
            var foundCategoryModel;
            var foundSubCategoryModel;
            options = _.defaults(options || {}, {
                fetch: true,
                loadUrl: false,
            });

            if (options.filterVendor === null) {
              self._menuState.set(
                  'filterVendor',
                  null
              );
            }

            var vendorModel;
            if (options.vendor) {
              vendorModel = self._vendors.findWhere({ code: options.vendor });
              if (vendorModel) {
                options.filterVendor = vendorModel.get('id');
              }
            } else if (options.vendor === undefined && options.filterVendor) {
              vendorModel = self._vendors.findWhere({ id: options.filterVendor });
              if (vendorModel) {
                options.vendor = vendorModel.get('code');
              }
            } else if (self._menuState.get('filterVendor') !== null) {
              vendorModel = self._vendors.findWhere({ id: self._menuState.get('filterVendor') });
              if (vendorModel) {
                options.vendor = vendorModel.get('code');
                options.filterVendor = self._menuState.get('filterVendor');
              }
            }

            if (options.filterVendor !== null) {
              self._menuState.set(
                  'filterVendor',
                  options.filterVendor || this._menuState.get('filterVendor')
              );
            }

            categorySlug = categorySlug ?
                categorySlug :
                self._menuState.get('filterCategory');

            subCategorySlug =
                subCategorySlug ?
                subCategorySlug :
                self._menuState.get('filterSubCategory');

            foundCategoryModel = self._menuItemCategories.findWhere({
                slug: categorySlug
            });

            if (foundCategoryModel) {
                if (subCategorySlug) {
                    foundSubCategoryModel = self._menuItemCategories.findWhere({
                        slug: subCategorySlug
                    });
                }
            }

            var filterCategory =
                foundCategoryModel ? foundCategoryModel.get('slug') : 'all';

            var filterSubCategory =
                foundSubCategoryModel ? foundSubCategoryModel.get('slug') : 'all';

            if (filterSubCategory && filterSubCategory !== 'all') {
                self._menuState.set('slug', filterSubCategory);
            } else {
                self._menuState.set(
                    'slug',
                    filterCategory
                );
            }

            self._menuState.set(
                'filterCategory',
                filterCategory
            );

            self._menuState.set(
                'filterSubCategory',
                filterSubCategory
            );

            self._menuState.set(
                'filterSort',
                options.sort || this._menuState.get('filterSort')
            );

            var filterLocation =
                options.location || this._menuState.get('filterLocation');

            self._menuState.set('filterLocation',
              filterLocation
            );

            LocationEntities.saveUserLocation(filterLocation);

            self._menuState.set(
                'filterSearch',
                options.searchTerm || this._menuState.get('filterSearch')
            );

            self._menuState.set(
                'filterSaleItems',
                options.filterSaleItems || this._menuState.get('filterSaleItems')
            );

            self._menuState.set(
                'filterNewItems',
                options.filterNewItems || this._menuState.get('filterNewItems')
            );

            self._menuState.set(
                'filterClearanceItems',
                options.filterClearanceItems || this._menuState.get('filterClearanceItems')
            );

            var updateURLParts = [filterCategory];
            if (filterSubCategory && filterSubCategory !== 'all') {
                updateURLParts.push(filterSubCategory);
            }

            if (filterLocation && filterLocation !== 'all') {
                updateURLParts.push('location/' + filterLocation);
            }

            if (options.vendor && options.filterVendor) {
                updateURLParts.push('brand/' + options.vendor);
            }
            if (!window.location.origin) {
              window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
            }
            var fullURL;

            if (self.options.mode === 'kiosk') {
              fullURL = window.location.origin + window.location.pathname + '#' + updateURLParts.join('/');
            } else {
              fullURL = window.location.origin + '/menu' + '#' + updateURLParts.join('/');
            }
            if (options.loadUrl === true && options.fetch === true) {
              try {
                  window.stop();
              } catch (exception) {
                  document.execCommand('Stop');
              }
              $(location).prop('href', fullURL);
              return;
            }

            self._appChannel.request('navigate:to', updateURLParts.join('/'));

            if (self.options.mode !== 'global') {
              self._hideExpandedProduct();
              var menu = self._renderMenuItems();
              menu.showItems();
              menu.maybeShowSearch();
              menu.maybeShowFilters();
              if (options.fetch) {
                  self._menuState.set('currentPage', 1);
                  self._menuState.set('retrievingPageData', false);
                  if (self._fetchingCategoryProductsXHR) {
                      self._fetchingCategoryProductsXHR.abort();
                      self._fetchingCategoryProductsXHR = null;
                  }
                  self.getCategoryProducts();
                  UIUtils.scrollToPageTop();
              }
              self._appChannel.trigger('active:view:add','thumbs');
            }
        },
        setupRouter: function() {
            var self = this;
            self._menuRouter = new Router({
                controller: self
            });

            self._menuRouter.on('route', function (routeName, routePath, routeArgs) {
              self._globalChannel.trigger('add:navigation:history:entry', {
                  name: routeName,
                  args: routeArgs,
                  fragment: Backbone.history.fragment
              });
            });

            if (!Backbone.History.started) {
                Backbone.history.start({
                    root: '/'
                });
            }
        },
        handleCategoryRoute: function (categorySlug, subCategorySlug, location, vendor) {

            var _checkLocationtTempClosed = this._checkLocationtTempClosed(location);
            if (_checkLocationtTempClosed) {
              location = _checkLocationtTempClosed;
            }

            if (categorySlug) {
                categorySlug = categorySlug.toLowerCase().replace(' ', '-');
            }
            if (subCategorySlug) {
                subCategorySlug = subCategorySlug.toLowerCase().replace(' ', '-');
            }

            if (this.options.mode === 'kiosk') {
              if (this._initialRoute == true) {
                this._showIntro();
              }
            }

            var navigationHistory = this._appChannel.request('get:navigation:history');

            if (navigationHistory.length >= 2 &&
              navigationHistory[navigationHistory.length - 1].args &&
              navigationHistory[navigationHistory.length - 1].args[0] == 'products') {

              var navigationHistoryLastEntry = navigationHistory[navigationHistory.length - 2];
              if (navigationHistoryLastEntry) {
                if (navigationHistoryLastEntry.args == undefined) {
                  navigationHistoryLastEntry.args = navigationHistoryLastEntry.fragment.split('/');
                }
                if (navigationHistoryLastEntry.args[0] == 'all' && navigationHistoryLastEntry.args[0] == categorySlug ||
                navigationHistoryLastEntry.args[0] == categorySlug && navigationHistoryLastEntry.args[1] == subCategorySlug ||
              navigationHistoryLastEntry.args[0] == categorySlug && subCategorySlug == null) {
                  if (this.options.mode !== 'global') {
                    this._hideExpandedProduct();
                    if (this._menu && this._menu.isRendered) {
                      this._menu.showItems();
                      this._menu.maybeShowSearch();
                      this._menu.maybeShowFilters();
                    }
                    this._appChannel.trigger('active:view:add','thumbs');
                  }
                  return;
                }
              }

            } // end if navigationHistory.length >= 2

            this._initialRoute = false;
            this.loadCategory(categorySlug, subCategorySlug, { location: location, vendor: vendor });
        },
        handleProductRoute: function (productSlug) {
            this.loadProduct(productSlug);
        },
        getNextPageData: function() {
            if (this._menuState.get('lastPage') || this._menuState.get('retrievingPageData')) {
                return;
            }
            var currentPage = this._menuState.get('currentPage') + 1;
            this._menuState.set('currentPage', currentPage);
            this.getCategoryProducts();
        },
        getCategoryProducts: function() {
            var self = this;

            var searchAttrs = [
                'itemsPerPage',
                'currentPage',
                'slug',
                'filterSearch',
                'filterLocation',
                'filterSort',
                'filterVendor',
                'filterSaleItems',
                'filterNewItems',
                'filterClearanceItems'
            ];

            if (self.shouldDormantTimerBeEnabled()) {
              self._resetDormantTimer();
            }

            if (self._menuState.get('retrievingPageData')) {
                return;
            }
            if (self._previousQuery &&
                _.isEqual(self._menuState.pick(searchAttrs), self._previousQuery.pick(searchAttrs)))
            {
                return;
            }
            self._menuState.set('retrievingPageData', true);

            self._previousQuery = new Backbone.Model(
                self._menuState.pick(searchAttrs)
            );

            if (self._menuState.get('currentPage') == 1) {
                self._menuItems.reset();
            }

            var filterLocation = self._menuState.get('filterLocation');
            var filterVendor = self._menuState.get('filterVendor');

            var filterSubCategory = self._menuState.get('filterSubCategory');
            var filterCategory = self._menuState.get('filterCategory');
            var filterCategorySlugs = self._menuState.get('filterCategorySlugs');
            var filterCategorySlug = null;
            if (filterCategorySlugs && filterCategory === 'all') {
                filterCategorySlug = filterCategorySlugs;
            } else if (filterSubCategory && filterSubCategory !== 'all') {
                filterCategorySlug = filterSubCategory;
            } else if(filterCategory && filterCategory !== 'all') {
                filterCategorySlug = filterCategory;
            }


            var fetchParams = {
              per_page: self.calculateNextPageFetchNum(),
              in_stock: true,
              page: self._menuState.get('currentPage'),
              product_ids: self._menuState.get('productIDs'),
              search_term: self._menuState.get('filterSearch'),
              category_slug: filterCategorySlug,
              remove_out_stock_variation: false,
              customer_ordering: true,
              filter_location: filterLocation === 'all' ? null : filterLocation,
              vendor_id: isNaN(filterVendor) ? null : filterVendor,
              orderby: self._menuState.get('filterSort'),
              filter_vendor: self._menuState.get('filterVendor'),
              filter_sale_items: self._menuState.get(
                  'filterSaleItems'
              ),
              filter_clearance_items: self._menuState.get('filterClearanceItems'),
              filter_new_items: self._menuState.get(
                  'filterNewItems'
              )
            };

            self._fetchingCategoryProductsXHR = self._menuItems.fetch({
                remove: self._menuState.get('currentPage') == 1 ? true : false,
                data: fetchParams,
                success: function (collection, response, options) {
                    self._menuState.set('retrievingPageData', false);
                    var numPages =
                        parseInt(options.xhr.getResponseHeader('X-WP-TotalPages'), 10);
                    var page =
                        parseInt(options.xhr.getResponseHeader('X-WP-Page'), 10);

                    self._menuState.set('lastPage', page === numPages);
                },
                error: function (collection, response, options) {
                    self._menuState.set('retrievingPageData', false);
                }
            });
        },
        _addGlobalAjaxErrorHandler: function () {
            var self = this;
            $(document).ajaxError(function (e, xhr, options) {
                if (xhr.status == 403) {
                    location.reload();
                    //todo: figure out why the dialog isn't showing...
                    /*
                    self._appChannel.trigger(
                        'show:confirm:dialog',
                        {
                            showCancelButton: false,
                            confirmText: 'The security for this page has expired. Please refresh.',
                            confirmButtonLabel: 'Refresh',
                            confirmedCallback: function () {
                                location.reload();
                            }
                        }
                    );
                    */
                }
            });
        },
        renderPageNotFoundPage: function () {
            this._hideExpandedProduct();
            this._appChannel.request('scroll:to:page:top');
            this.mainRegion.show(new (require('./common/page-not-found'))({}));
        },
        _setupDialog: function () {
            var self = this;
            var DialogController =
                require('treeline-shared-components/dialog').Controller;
            new DialogController({
                container: this.overlayRegion,
                channel: Backbone.Radio.channel('dialog')
            });
            self._globalChannel.on(
                'show:confirm:dialog',
                function (options) {
                    var ConfirmDialog = require('treeline-shared-components/confirm-dialog').View;
                    new ConfirmDialog(_.extend(options, {
                        channel: Backbone.Radio.channel('dialog')
                    }));
                }
            );
        },
        _serverUnixTime: function () {
          var currentSelectedLocation = this._appChannel.request('get:filter:location:details');
          if (currentSelectedLocation && currentSelectedLocation.get('server_client_time_offset')) {
            return moment().unix() + currentSelectedLocation.get('server_client_time_offset');
          } else {
            return null;
          }
        },
        _displayEntryDialog: function (options) {
          var self = this;
          var options = _.defaults(
              options || {},
              {
                  skipAgeGate: false,
                  referrer: 'entry',
                  view: 'entry' // entry, order_success
              }
          );
          
          var elementId =  '#farm-complete-overlay-modal';

          var modal = self._entryModal;
          if (!modal) {
              modal = self._entryModal = new DynamicRegion({
                  el: elementId
              });
              modal.on('show', function () {
                  modal.$el.addClass('enableClick');
                  modal.$el.css({ 'overflow-y': 'hidden' });
                  modal.$el.addClass('darkTheme');
                  modal.$el.css({ opacity: 1 });
              });
              modal.on('empty', function () {
                  modal.$el.removeClass('enableClick');
                  modal.$el.css({ 'overflow-y': 'scroll' });
                  modal.$el.removeClass('darkTheme');
                  modal.$el.css({ opacity: 0 });
                  self._appChannel.trigger('active:view:remove','entryModal');
              });
          }


          var view = new EntryFlow({
            _appChannel: self._appChannel,
            _menuState: self._menuState,
            skipAgeGate: options.skipAgeGate,
            referrer: options.referrer,
            delivery_method: self.options.delivery_method
          });

          view.on('close:clicked', function() {
              modal.empty();
          });

          modal.show(view);
          self._appChannel.trigger('active:view:add','entryModal');
        },
        _maybeDisplayEntryDialog: function () {
          var self = this;
          lsCache.flushExpired();
          var lastAgeGateYesClicked = lsCache.get('lastAgeGateYesClickedTime');
          if (!lastAgeGateYesClicked) {
            this._displayEntryDialog();
            return;
          }
          if (this.options.delivery_method !== null) {
            this._displayEntryDialog({
              skipAgeGate: true
            });
          }
        },
        _hideSideBarMenu: function () {
          var self = this;
          if (self._sideBarModal) {
            self._sideBarModal.empty();
            self._appChannel.trigger('active:view:remove','sidebar');
          }
        },
        _displaySideBarMenu: function (options) {
          var self = this;
          self._sideBarModal = self._sideBarMenu;

          if (!self._sideBarModal) {
              self._sideBarModal = self._sideBarMenu = new DynamicRegion({
                  el: '#farm-sidebar-modal'
              });
            self._sideBarModal.on('show', function () {
                  self._sideBarModal.$el.css({ 'overflow-y': 'scroll' });
                  self._sideBarModal.$el.addClass('enableClick');
                  self._sideBarModal.$el.css({ opacity: 1 });
                  self._menuState.set('sideBarOpen', true);
              });
              self._sideBarModal.on('empty', function () {
                  self._menuState.set('sideBarOpen', false);
                  self._sideBarModal.$el.css({ 'overflow-y': 'hidden' });
                  self._sideBarModal.$el.removeClass('enableClick');
                  self._sideBarModal.$el.css({ opacity: 0 });
                  self._appChannel.trigger('active:view:remove','sidebar');
              });
          }

          var view = new SidebarModal(_.extend({
            _appChannel: self._appChannel,
            isUserLoggedIn: self.options.isUserLoggedIn,
            customerData: self._appChannel.request('customer:get:data')
          }, options));

          view.on('close:clicked', function() {
              self._sideBarModal.empty();
          });

          self._sideBarModal.show(view);
          self._appChannel.trigger('active:view:add','sidebar');
        },
        _hideSearchMenu: function () {
          var self = this;
          if (self._searchModal) {
            self._searchModal.empty();
            self._appChannel.trigger('active:view:remove','search');
          }
        },
        _displaySearchMenu: function (options) {
          var self = this;
          self._searchModal = self._searchMenu;

          if (!self._searchModal) {
              self._searchModal = self._searchMenu = new DynamicRegion({
                  el: '#farm-search-modal'
              });
            self._searchModal.on('show', function () {
                  self._searchModal.$el.css({ 'overflow-y': 'scroll' });
                  self._searchModal.$el.addClass('enableClick');
                  self._searchModal.$el.css({ opacity: 1 });
                  self._menuState.set('searchOpen', true);
              });
              self._searchModal.on('empty', function () {
                  self._menuState.set('searchOpen', false);
                  self._searchModal.$el.css({ 'overflow-y': 'hidden' });
                  self._searchModal.$el.removeClass('enableClick');
                  self._searchModal.$el.css({ opacity: 0 });
                  self._appChannel.trigger('active:view:remove','search');
              });
          }

          var view = new SearchModal(_.extend({
            _appChannel: self._appChannel,
            _menuState: self._menuState,
            isUserLoggedIn: self.options.isUserLoggedIn,
            searchType: self.options.searchType,
            algolia: self._settings.get('algolia'),
            customerData: self._appChannel.request('customer:get:data')
          }, options));

          view.on('close:clicked', function() {
              self._searchModal.empty();
          });

          self._searchModal.show(view);
          self._appChannel.trigger('active:view:add','search');
        },
        _hideExpandedCart: function () {
          var self = this;
          if (self._expandedCartModal) {
            self._expandedCartModal.empty();
            self._appChannel.trigger('active:view:remove','sidebar');
          }
        },
        _displayExpandedCart: function (options) {
          var self = this;

          var options = _.defaults(
              options || {},
              {
                  state: 'review',
                  order: null
              }
          );

          self._appChannel.trigger('menu:overlay:view:close');
          self._expandedCartModal = self._expandedCart;

          if (!self._expandedCartModal) {
              self._expandedCartModal = self._expandedCart = new DynamicRegion({
                  el: '#farm-inline-modal'
              });
              self._expandedCartModal.on('show', function () {
                  self._expandedCartModal.$el.css({ 'overflow-y': 'scroll' });
                  self._expandedCartModal.$el.addClass('enableClick');
                  self._expandedCartModal.$el.css({ opacity: 1 });
              });
              self._expandedCartModal.on('empty', function () {
                  self._expandedCartModal.$el.css({ 'overflow-y': 'hidden' });
                  self._expandedCartModal.$el.removeClass('enableClick');
                  self._expandedCartModal.$el.css({ opacity: 0 });
                  self._appChannel.trigger('active:view:remove','reviewCart');
                  self._appChannel.trigger('active:view:remove','paymentCart');
                  self._appChannel.trigger('active:view:remove','successCart');
                  self._appChannel.trigger('active:view:remove','challengeCart');
                  if (self._cart) {
                    self._cart.clearCardDetails();
                  }
              });
          }

          var view = new CartExpandedModal(_.extend({
            _appChannel: self._appChannel
          }, options));

          view.on('close:clicked', function() {
              self._expandedCartModal.empty();
          });

          self._expandedCartModal.show(view);
          self._appChannel.trigger('active:view:add', options.state + 'Cart');
        },
        _expandedCartChangeState: function (options) {
          this._appChannel.trigger('active:view:remove','reviewCart');
          this._appChannel.trigger('active:view:remove','paymentCart');
          if (this._expandedCartModal && this._expandedCartModal.currentView) {
            this._expandedCartModal.currentView.ChangeState(options);
            this._appChannel.trigger('active:view:add', options.state + 'Cart');
          } else {
            this._displayExpandedCart(options);
          }
        },
        _hideExpandedLocationSelection: function () {
          var self = this;
          if (self._expandedLocationDisplayModal) {
            self._expandedLocationDisplayModal.empty();
            self._appChannel.trigger('active:view:remove','locationSelect');
          }
        },
        _displayExpandedLocationSelection: function (options) {
          var self = this;

          self._expandedLocationDisplayModal = self._expandedLocationDisplay;

          if (!self._expandedLocationDisplayModal) {
              self._expandedLocationDisplayModal = self._expandedLocationDisplay = new DynamicRegion({
                  el: '#farm-inline-modal'
              });
              self._expandedLocationDisplayModal.on('show', function () {
                  self._expandedLocationDisplayModal.$el.css({ 'overflow-y': 'scroll' });
                  self._expandedLocationDisplayModal.$el.addClass('enableClick');
                  self._expandedLocationDisplayModal.$el.css({ opacity: 1 });
              });
              self._expandedLocationDisplayModal.on('empty', function () {
                  self._expandedLocationDisplayModal.$el.css({ 'overflow-y': 'hidden' });
                  self._expandedLocationDisplayModal.$el.removeClass('enableClick');
                  self._expandedLocationDisplayModal.$el.css({ opacity: 0 });
                  self._appChannel.trigger('active:view:remove','locationSelect');
              });
          }

          var view = new LocationExpandedModal(_.extend({
            _appChannel: self._appChannel,
            _menuState: self._menuState
          }, options));

          view.on('close:clicked', function() {
              self._expandedLocationDisplayModal.empty();
          });

          self._expandedLocationDisplayModal.show(view);

          self._appChannel.trigger('active:view:add','locationSelect');
        },
        _hideMegaMenu: function () {
          var self = this;
          if (self._megaMenuModal) {
            self._megaMenuModal.empty();
            // doubling up, maybe...
            self._appChannel.trigger('active:view:remove','megaMenu');
          }
        },
        _displayMegaMenu: function (options) {
          var self = this;

          self._megaMenuModal = self._megaMenu;

          if (!self._megaMenuModal) {
              self._megaMenuModal = self._megaMenu = new DynamicRegion({
                  el: '#farm-mega-menu-modal'
              });
              self._megaMenuModal.on('show', function () {
                  self._megaMenuModal.$el.css({ 'overflow-y': 'scroll' });
                  self._megaMenuModal.$el.addClass('enableClick');
                  self._megaMenuModal.$el.css({ opacity: 1 });
              });
              self._megaMenuModal.on('empty', function () {
                  self._megaMenuModal.$el.css({ 'overflow-y': 'hidden' });
                  self._megaMenuModal.$el.removeClass('enableClick');
                  self._megaMenuModal.$el.css({ opacity: 0 });
                  self._appChannel.trigger('active:view:remove','megaMenu');
                  self._appChannel.trigger('menu:overlay:view:close','megamenu');
                  self._globalChannel.trigger('menu:overlay:view:close','megamenu');
              });
          }

          var view = new MegaMenuModal(_.extend({
            _menuState: self._menuState,
            _appChannel: self._appChannel
          }, options));

          view.on('close:clicked', function() {
              self._megaMenuModal.empty();
          });

          self._megaMenuModal.show(view);

          self._appChannel.trigger('active:view:add','megaMenu');
        },
        _hideClickBlocker: function () {
          var self = this;
          if (self._clickBlockerModal) {
            self._clickBlockerModal.empty();
          }
        },
        _displayClickBlocker: function () {
          var self = this;
          self._clickBlockerModal = self._clickBlocker;
          if (!self._clickBlockerModal) {
              self._clickBlockerModal = self._clickBlocker = new DynamicRegion({
                  el: '#farm-complete-overlay-modal'
              });
              self._clickBlockerModal.on('show', function () {
                  self._clickBlockerModal.$el.addClass('enableClick');
                  self._clickBlockerModal.$el.css({ opacity: 0 });
              });
              self._clickBlockerModal.on('empty', function () {
                  self._clickBlockerModal.$el.removeClass('enableClick');
                  self._clickBlockerModal.$el.css({ opacity: 0 });
              });
          }

          var view = new ClickBlockerModal({
            appChannel: self._appChannel
          });

          view.on('close:clicked', function() {
              self._clickBlockerModal.empty();
          });

          self._clickBlockerModal.show(view);

        },
        _displayProductZoomer: function (model) {
          var self = this;
          var modal = self._expandedProductZoomer;
          if (!modal) {
              modal = self._expandedProductZoomer = new DynamicRegion({
                  el: '#farm-complete-overlay-modal'
              });
              modal.on('show', function () {
                  modal.$el.addClass('enableClick');
                  modal.$el.css({ 'overflow-y': 'hidden' });
                  if (model.get('theme') === 'dark') {
                    modal.$el.addClass('darkTheme');
                  }
                  modal.$el.css({ opacity: 1 });
              });
              modal.on('empty', function () {
                  modal.$el.removeClass('enableClick');
                  modal.$el.css({ 'overflow-y': 'scroll' });

                  if (modal.$el.hasClass('darkTheme')) {
                    modal.$el.removeClass('darkTheme');
                  }
                  modal.$el.css({ opacity: 0 });
                  self._appChannel.trigger('active:view:remove','productZoomer');
              });
          }


          var view = new ProductZoomerModal({
            theme: model.get('theme'),
            model: model,
            appChannel: self._appChannel
          });

          view.on('close:clicked', function() {
              modal.empty();
          });

          modal.show(view);
          self._appChannel.trigger('active:view:add','productZoomer');
        },
        _displayEnlargedVideo: function (model, collection) {
          var self = this;
          var modal = self._expandedVideo;

          if (!modal) {
              modal = self._expandedVideo = new DynamicRegion({
                  el: '#farm-complete-overlay-modal'
              });
              modal.on('show', function () {
                  modal.$el.css({ 'overflow-y': 'hidden' });
                  modal.$el.addClass('enableClick');
                  modal.$el.addClass('darkTheme');
                  modal.$el.css({ opacity: 1 });
              });
              modal.on('empty', function () {
                  modal.$el.css({ 'overflow-y': 'scroll' });
                  modal.$el.removeClass('enableClick');
                  modal.$el.removeClass('darkTheme');
                  modal.$el.css({ opacity: 0 });
                  self._appChannel.trigger('active:view:remove','productVideo');
              });
          }

          var view = new VideoExpandedModal({
            model: model,
            collection: collection,
            appChannel: self._appChannel
          });

          view.on('close:clicked', function() {
              modal.empty();
          });

          modal.show(view);
          self._appChannel.trigger('active:view:add','productVideo');
        },
        _displayModal: function (options) {
          var self = this;
          self.modal = self._expandedModal;

          var options = _.defaults(options || {}, {
            appChannel: self._appChannel
          });

          if (!self.modal) {
              self.modal = self._expandedModal = new DynamicRegion({
                  el: '#farm-inline-modal'
              });
              self.modal.on('show', function () {
                  self.modal.$el.css({ 'overflow-y': 'hidden' });
                  self.modal.$el.addClass('enableClick');
                  self.modal.$el.addClass('darkTheme');
                  self.modal.$el.css({ opacity: 1 });
              });
              self.modal.on('empty', function () {
                  self.modal.$el.css({ 'overflow-y': 'scroll' });
                  self.modal.$el.removeClass('enableClick');
                  self.modal.$el.removeClass('darkTheme');
                  self.modal.$el.css({ opacity: 0 });
                  self._appChannel.trigger('active:view:remove','modal');
                  if (self._menu && self._menu.isRendered) {
                    self._menu.showItems();
                    self._menu.maybeShowSearch();
                    self._menu.maybeShowFilters();
                  }
              });
          }

          var view = new Modal(options);

          view.on('close:clicked', function() {
              self.modal.empty();
          });

          self.modal.show(view);
          self._appChannel.trigger('active:view:add','modal');
        },
        _displayFooterControlBar: function () {
          var self = this;
          this._footerBarRegion = new FooterDynamicRegion({
              el: '#farm-complete-overlay-tools'
          });

          this._footerControlBar = new FooterControlBar({
            _appChannel: this._appChannel,
            _menuState: this._menuState
          });

          this._footerBarRegion.show(this._footerControlBar);
        },
        _displayKioskControlBar: function () {
          var self = this;
          this._headerBarRegion = new HeaderDynamicRegion({
              el: '#farm-kiosk-header'
          });

          this._headerControlBarKiosk = new HeaderControlBarKiosk({
            isUserLoggedIn: self.options.isUserLoggedIn,
            _appChannel: this._appChannel,
            _menuState: this._menuState
          });

          this._headerBarRegion.show(this._headerControlBarKiosk);
        },
        _displayHeaderControlBar: function () {
          var self = this;
          this._headerBarRegion = new HeaderDynamicRegion({
              el: '#farm-header-tools'
          });

          this._headerControlBar = new HeaderControlBar({
            isUserLoggedIn: self.options.isUserLoggedIn,
            _appChannel: this._appChannel,
            _menuState: this._menuState
          });

          this._headerBarRegion.show(this._headerControlBar);
        },

        _displaySessionTimoutOverlay: function () {

          if (this._showingIntro !== null && this._showingIntro == true) {
            return;
          }

          var self = this;
          var modal = self._sessionTimoutOverlay;

          if (!modal) {
              modal = self._sessionTimoutOverlay = new DynamicRegion({
                  el: '#farm-complete-overlay-modal'
              });
              modal.on('show', function () {
                modal.$el.css({ 'overflow-y': 'scroll' });
                modal.$el.addClass('enableClick');
                modal.$el.addClass('darkTheme');
                modal.$el.css({ opacity: 1, paddingBottom: 0});
              });
              modal.on('empty', function () {
                  modal.$el.css({ 'overflow-y': 'hidden' });
                  modal.$el.removeClass('enableClick');
                  modal.$el.removeClass('darkTheme');
                  modal.$el.css({ opacity: 0, paddingBottom: 74});
                  if (self.shouldDormantTimerBeEnabled()) {
                    self._resetDormantTimer();
                  }
                  self._appChannel.trigger('active:view:remove','sessionTimeoutOverlay');
              });
          }

          var view = new SessionTimoutOverlay({
            appChannel: self._appChannel
          });

          view.on('finished', function () {
            if (self.options.reloadOnSessionTimeout) {
              self._hideExpandedProduct();
              modal.empty();
              self._appChannel.request('navigate:to', '/');
              _.delay(function () {
                location.reload();
              }, 100);

            } else {
              self._hideExpandedProduct();
              modal.empty();
              self._showIntro();
            }
            self._appChannel.trigger('active:view:remove','sessionTimeoutOverlay');
          });

          view.on('close:clicked', function() {
              modal.empty();
          });

          modal.show(view);
          self._appChannel.trigger('active:view:add','sessionTimeoutOverlay');
        },
        _showIntro: function () {
          var self = this;
          this._showingIntro = true;
          var self = this;
          var modal = self._kioskIntroOverlay;

          if (!modal) {
              modal = self._kioskIntroOverlay = new DynamicRegion({
                  el: '#farm-complete-overlay-modal'
              });
              modal.on('show', function () {
                  modal.$el.css({ 'overflow-y': 'scroll' });
                  modal.$el.addClass('enableClick');
                  modal.$el.addClass('darkTheme');
                  modal.$el.css({ opacity: 1, paddingBottom: 0});
              });
              modal.on('empty', function () {
                  modal.$el.css({ 'overflow-y': 'hidden' });
                  modal.$el.removeClass('enableClick');
                  modal.$el.removeClass('darkTheme');
                  modal.$el.css({ opacity: 0, paddingBottom: 74});
                  self._appChannel.trigger('active:view:remove','kioskIntro');
              });
          }

          var view = new KioskIntroOverlay({
            appChannel: self._appChannel
          });

          view.on('menu:show:category', function (cat) {
            self._appChannel.request(
                'load:category',
                cat,
                'all',
                {
                  mode: 'kiosk'
                }

            );
            modal.empty();
            self._showingIntro = false;
          });

          modal.show(view);
          self._appChannel.trigger('active:view:add','kioskIntro');
        },
        _hideExpandedProductLoader: function () {
          if (this._expandedProductDialogLoader) {
            this._expandedProductDialogLoader.empty();
          }
        },
        _displayExpandedProductLoader: function(productModel) {
            var self = this;
            var dialog = self._expandedProductDialogLoader;

            if (!dialog) {
                dialog = self._expandedProductDialogLoader = new DynamicRegion({
                    el: '#et-main-area-modal'
                });
                dialog.on('show', function () {
                    dialog.$el.addClass('enableClick');
                    dialog.$el.css({ 'overflow-y': 'hidden' });
                    dialog.$el.css({ opacity: 1 });
                });
                dialog.on('empty', function () {
                    dialog.$el.removeClass('enableClick');
                    dialog.$el.css({ 'overflow-y': 'hidden' });
                    dialog.$el.css({ opacity: 0 });
                });
            }
            var theme = 'light';
            if (productModel) {
              if (productModel.get('theme') === 'dark') {
                theme = 'dark';
              }
            }
            var loaderExpanded = new LoaderExpanded({
              theme: theme
            });
            dialog.show(loaderExpanded);
        },
        _displayExpandedProduct: function(model) {
            var self = this;
            self._menuState.set('displayingExpandedView', true);
            self._menuState.set('displayedProduct', model);

            if (self.shouldDormantTimerBeEnabled()) {
              self._resetDormantTimer();
            }

            var dialog = self._expandedProductDialog;
            if (!dialog) {
                dialog = self._expandedProductDialog = new DynamicRegion({
                    el: '#et-main-area-modal'
                });
                dialog.on('show', function () {
                    dialog.$el.addClass('enableClick');
                    dialog.$el.css({ 'overflow-y': 'scroll' });
                    if (self._menuState.get('displayedProduct').get('theme') === 'dark') {
                      $('body').addClass('fmcy-product-tile-theme-dark');
                    } else {
                      if ($('body').hasClass('fmcy-product-tile-theme-dark')) {
                        $('body').removeClass('fmcy-product-tile-theme-dark');
                      }
                    }
                    dialog.$el.css({ opacity: 1 });
                });
                dialog.on('empty', function () {
                    dialog.$el.removeClass('enableClick');
                    dialog.$el.css({ 'overflow-y': 'hidden' });
                    dialog.$el.css({ opacity: 0 });
                    self._appChannel.trigger('active:view:remove','productEnlarged');
                    if (self.options.mode == 'embedded') {
                      if (self._menu && self._menu.isRendered) {
                        self._menu.showItems();
                        self._menu.maybeShowSearch();
                        self._menu.maybeShowFilters();
                      }
                    }
                });
            }

            var view = new MenuItemExpanded({
                locations: self._locations,
                model: model,
                mode: self.options.mode,
                isUserLoggedIn: self._menuState.get('isUserLoggedIn'),
                filterLocation: self._menuState.get('filterLocation'),
                shouldRenderProductLocations: false,
                customClassName: 'fmcy-menu-expanded-product',
                appChannel: self._appChannel,
                onlinePurchaseEnabled: self._shouldEnableOnlinePurchaseForProduct(model),
                showProductLocations: self._menuState.get('multiLocationsSupportEnabled'),
                showOnlineProductLocations: self._menuState.get('isUserLoggedIn')
            });

            view.on('close:clicked', function() {
                dialog.empty();
                if (self.options.redirectURL) {
                    if (self._appChannel.request('get:navigation:history').length) {
                        window.history.back();
                    } else {
                        try {
                          window.stop();
                        } catch (exception) {
                          document.execCommand('Stop');
                        }
                        $(location).prop('href', self.options.redirectURL);
                    }
                } else {
                    var category = self._menuState.get('filterCategory');
                    if (category) {
                        self._appChannel.request(
                            'load:category',
                            null,
                            null,
                            {
                                fetch: false
                            }
                        );
                    } else {
                        var productCategory = model.get('category');
                        var productSubCategory = model.get('subCategory');
                        self._appChannel.request(
                            'load:category',
                            productCategory ? productCategory.toLowerCase() : null,
                            productSubCategory ? productSubCategory.toLowerCase() : null
                        );
                    }
                }
            });
            dialog.show(view);
            self._appChannel.trigger('active:view:add','productEnlarged');
        },
        _hideExpandedProduct: function() {
            this._menuState.set('displayedProduct', null);
            if (this._expandedProductDialog) {
                this._expandedProductDialog.empty();
                this._menuState.set('displayingExpandedView', false);
            }
        },
        _shouldEnableOnlinePurchaseForProduct: function (product) {
            if (this.shouldAddToCartBeEnabled()) {
              return true;
            } else {
              return false;
            }
        }
    });

    $('.farmacy-menu').each(function(index) {
      renderMenu(this);
    });

    function renderMenu(el) {
        new PublicMenuApp({
            el: el,
            instanceId: $(el).data('instanceid'),
            mode: $(el).data('mode'),
            thumbStyle: $(el).data('thumbstyle'),
            delivery_method: $(el).data('deliverymethod'),
            filter: $(el).data('filter'),
            filterLocation: $(el).data('filterlocation'),
            filterVendor: parseInt($(el).data('filtervendor')),
            filterCategorySlugs: $(el).data('filtercategoryslugs'),
            saleItemsFilterEnabled: $(el).data('saleitemsfilterenabled'),
            newItemsFilterEnabled: $(el).data('newitemsfilterenabled'),
            clearanceItemsFilterEnabled: $(el).data('clearanceitemsfilterenabled'),
            sort: $(el).data('sort'),
            locations: $(el).data('locations'),
            productCategories: $(el).data('productcategories'),
            cartData: $(el).data('cartdata'),
            productVendors: $(el).data('productvendors'),
            productIDs: $(el).data('productids'),
            isUserLoggedIn: $(el).data('isuserloggedin'),
            userData: $(el).data('userdata'),
            userId: $(el).data('userid'),
            multiLocationsSupportEnabled: $(el).data('multilocationssupportenabled'),
        }).start();
        if ($(el).data('mode') === 'kiosk') {
            $('.fmcy-header-control-bar').hide();
            $('.page-container-farm').attr('style', 'padding-top: 80px !important');
            require('./elo-app/elo-app.scss');
        }
    }
});



/** WEBPACK FOOTER **
 ** ./assets/js/public-menu-app.js
 **/